export function handleRedirection(redirect: string, data: any, newTab: boolean) {
    var redirectURL = location.protocol + "//" + location.hostname + ":" + location.port + location.pathname;
    switch (redirect) {
        case "back":
            let previousRoute = localStorage.getItem("previousRoute");
            if (previousRoute !== null) {
                redirectURL = previousRoute;
            } else {
                redirectURL = '/';
            }
            break;
        case "continue":
            redirectURL += "?action=edit&id=" + data;
            break;
        default:
            redirectURL = redirect;
            break;
    }
    if (newTab) {
        window.open(redirectURL);
    }
    else {
        (window.location as any) = redirectURL;
    }
}

(window as any).handleRedirection = handleRedirection;